var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortDsc2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.652,
    height: 8,
    viewBox: "0 0 6.652 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "down-arrow_up",
    transform: "translate(48.112 8) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.46)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.984,4.366,47.722,4.1a.434.434,0,0,0-.309-.128.458.458,0,0,0-.319.128L45.4,5.788V.438A.421.421,0,0,0,                 44.981,0H44.61a.46.46,0,0,0-.462.438v5.37L42.458,4.1a.421.421,0,0,0-.3-.128.428.428,                 0,0,0-.306.128l-.261.262a.438.438,0,0,0,0,.619l2.887,2.887A.436.436,0,0,0,44.786,8h0a.435.435,0,0,0,                 .309-.128l2.887-2.887A.438.438,0,0,0,47.984,4.366Z",
    transform: "translate(-41.46 0)",
    fill: "#303030"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDsc2);
export default __webpack_public_path__ + "static/media/sort-dsc2.ed891f48.svg";
export { ForwardRef as ReactComponent };